// DatalistInput.tsx
import React from 'react';

interface DatalistInputProps {
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  options: string[];
  className?: string;
  disabled?: boolean;
}

export const DatalistInput: React.FC<DatalistInputProps> = ({
  name,
  value,
  onChange,
  placeholder = "",
  options,
  className = "w-48 text-center bg-transparent border-b border-black focus:outline-none py-0.5",
  disabled = false,
}) => {
  const listId = `${name}-options-list`;

  return (
    <>
      <input
        list={listId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
      />
      <datalist id={listId}>
        {options.map((option, index) => (
          <option key={`${option}-${index}`} value={option} />
        ))}
      </datalist>
    </>
  );
};